<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Categories</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card class="addadmin">
      <label class="inviteuser">Add Category</label>
  <div class="row">
      <div class="col d-flex justify-content-center">
        <mat-form-field [formGroup]="categoryForm" appearance="outline">
            <input matInput placeholder="Name" formControlName="name">
          </mat-form-field>
      </div>

      <!-- <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Position">
          </mat-form-field>
      </div> -->
  </div>
  <!-- <div class="col d-flex justify-content-center">
    <div style="margin-top: 20px ;">

      <span (click)="fileInput.click()" class="material-icons" style="color: blue;">
        cloud_upload
      </span>
      <label (click)="fileInput.click()" class="uploadimagetext">Upload Image</label>
      <br>
      <i matTooltip="For a better resolution, we recommend uploading a square picture">Recommended ratio 16:9</i>

      <form [formGroup]="categoryForm">
      <input formControlName="img" #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
        [uploader]="uploader" />
      </form>
      <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
      <div>
        <img class="uploadedimage" [src]="url" *ngIf="url"></div>

    </div>
  </div> -->
  <button (click)="submitCategory()" mat-flat-button color="primary">Create</button>
</mat-card>
<div >
<div  class="container">
  <div class="row">
  <div style="margin-top: 20px;" *ngFor="let el of categories; let i = index" class="col">
  <div class="card" style="width:400px">
    <!-- <img class="card-img-top" src="https://events.globalistic.tech{{el.url}}" alt="Card image" style="width:100%; max-height: 200px;"> -->
    <div class="card-body">
      <h4 class="card-title">Category Name: {{el.name}}</h4>
      <!-- <p class="card-text">Position:</p> -->
      <a style="color: white;" (click)="showCancellation(el.id)" class="btn deletecategorybutton">Delete Category</a>
    </div>
  </div>
</div>
</div>
</div>
</div>

<!-- Cancellation Reason Modal -->
  
<div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
aria-labelledby="myModalLabel" aria-hidden="true">
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel">Delete Category</h4>
      <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
        class="material-icons">highlight_off</i>

    </div>
    <div style="display: inline-block;">

      <div class="modal-body">
       
        <mat-label>Are you sure you want to delete this category?</mat-label>

        <button  (click)="deleteCategory()" class="confirmcancellation">Confirm</button>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>
</div>